import { render, staticRenderFns } from "./DetailCorrespondant.vue?vue&type=template&id=e64c74a6&scoped=true"
import script from "./DetailCorrespondant.vue?vue&type=script&lang=js"
export * from "./DetailCorrespondant.vue?vue&type=script&lang=js"
import style0 from "./DetailCorrespondant.vue?vue&type=style&index=0&id=e64c74a6&prod&scoped=true&lang=css"
import style1 from "./DetailCorrespondant.vue?vue&type=style&index=1&id=e64c74a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.41_babel-core@7.0.0-bridge.0_@babel+core@7.29._a26fb9023b752f5df33ae8450879cd09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64c74a6",
  null
  
)

export default component.exports